import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useTexture } from '@react-three/drei'
import * as THREE from 'three'

export default function Infoboard({ current, ...props }) {
  const { nodes, materials } = useGLTF('/Info-draco.glb')
  const texture1 = useTexture('/Images/kuva1.webp')
  const texture2 = useTexture('/Images/kuva2.webp')
  texture1.flipY = true
  texture1.wrapS = texture1.wrapT = THREE.RepeatWrapping
  texture1.repeat.x = -1 // flip horizontally
  texture1.encoding = THREE.sRGBEncoding
  texture1.minFilter = THREE.LinearMipmapLinearFilter
  texture1.magFilter = THREE.LinearFilter
  texture1.anisotropy = 4 

  texture2.encoding = THREE.sRGBEncoding
  texture2.minFilter = THREE.LinearMipmapLinearFilter
  texture2.magFilter = THREE.LinearFilter
  texture2.anisotropy = 4 
  texture2.flipY = false
  //texture2.wrapS = texture2.wrapT = THREE.RepeatWrapping
  //texture2.repeat.x = -1

  return <>
    {(current === 'wall') && (
      <>
        <directionalLight position={[1, 2, 3]} intensity={1.5} />
        <ambientLight intensity={0.3} />
      </>
    )}
    <group {...props} dispose={null} visible={current === 'wall' || current === 'home'}>

      <mesh
        name="kuva2"
        castShadow
        receiveShadow
        geometry={nodes.kuva2.geometry}
        position={[1.49, 1.81, 0.87]}
        rotation={[0, 0, -0.11]}
        scale={3.81}

      >
        <meshBasicMaterial map={texture2} toneMapped={false} />
      </mesh>
      <mesh
        name="kuva1"
        castShadow
        receiveShadow
        geometry={nodes.kuva1.geometry}
        position={[-4.53, 4.84, 0.73]}
        rotation={[0.05, 0, -3.11]}
        scale={3.98}
      >
        <meshBasicMaterial map={texture1} toneMapped={false} />
      </mesh>
      <mesh
        name="nasta3"
        castShadow
        receiveShadow
        geometry={nodes.nasta3.geometry}
        material={materials['Mat.2']}
        position={[-4.15, 8.35, 1.26]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={1.27}
      />
      <mesh
        name="nasta2"
        castShadow
        receiveShadow
        geometry={nodes.nasta2.geometry}
        material={materials['Mat.2']}
        position={[1.39, 5.2, 1.26]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={1.27}
      />
      <mesh
        name="nasta"
        castShadow
        receiveShadow
        geometry={nodes.nasta.geometry}
        material={materials['Mat.2']}
        position={[-5.59, -0.75, 1.26]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={1.27}
      />
      <group name="aurinkolasit" position={[-3.2, -7.4, 3.12]} rotation={[-0.22, -0.02, 1.29]}>
        <mesh
          name="aurinkolasit-lasi"
         castShadow
         receiveShadow
          position={[0, 0, 1]}
          geometry={nodes['aurinkolasit-lasi'].geometry}
          scale={4}
        >
          <meshStandardMaterial
          color='#d6ecf3'
          transparent
          opacity={0.4}
          roughness={0.1}
          metalness={0.05}
        />
      </mesh>
        <mesh
          name="aurinkolasit-arska"
          castShadow
          receiveShadow
          position={[0, 0, -0.5]}
          geometry={nodes['aurinkolasit-arska'].geometry}
          scale={4}
        >
          <meshStandardMaterial
          color='#9cc2cf'
          transparent
          opacity={0.99}
          roughness={0.2}
          metalness={0.05}
        />
      </mesh>

      </group>
        <mesh name="avaimet"
        castShadow
        receiveShadow
        geometry={nodes.avaimet.geometry}
        material={materials['arska.met']}
        position={[6.42, -2.51, 1.36]}
        scale={6.23}
        >
        <meshStandardMaterial
          color="#d4d4d4"
          metalness={0.65}
          roughness={0.1}
          envMapIntensity={1.5}
        />
      </mesh>
      <mesh name="koukku2"
        castShadow
        receiveShadow
        geometry={nodes.koukku2.geometry}
        material={materials['arska.met']}
        position={[6.05, 5.09, 1.29]}
        rotation={[0, Math.PI / 2, 0]}
        scale={2.25}
        >
        <meshStandardMaterial
          color="#c0c0c0"
          metalness={0.55}
          roughness={0.15}
          envMapIntensity={1.5}
        />
      </mesh>
      <mesh name="koukku"
        castShadow
        receiveShadow
        geometry={nodes.koukku.geometry}
        material={materials['arska.met']}
        position={[-3.3, -2.87, 1.29]}
        rotation={[0, Math.PI / 2, 0]}
        scale={2.25}
        >
        <meshStandardMaterial
          color="#c0c0c0"
          metalness={0.55}
          roughness={0.15}
          envMapIntensity={1.5}
        />
        </mesh>
      </group>
    </>
}

useGLTF.preload('/Info-draco.glb')
